// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTADocumentContent } from './dta-document-content';
import {
    DTADocumentContentFromJSON,
    DTADocumentContentFromJSONTyped,
    DTADocumentContentToJSON,
    DTADocumentContentToJSONTyped,
} from './dta-document-content';
import type { VersionStatus } from './version-status';
import {
    VersionStatusFromJSON,
    VersionStatusFromJSONTyped,
    VersionStatusToJSON,
    VersionStatusToJSONTyped,
} from './version-status';

/**
 * 
 * @export
 * @interface DTAVersion
 */
export interface DTAVersion {
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    change_reason: string;
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    change_source: string;
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    created_by: string;
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    data_stream_id?: string;
    /**
     * 
     * @type {DTADocumentContent}
     * @memberof DTAVersion
     */
    document_content?: DTADocumentContent;
    /**
     * 
     * @type {Array<string>}
     * @memberof DTAVersion
     */
    domains?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    dta_status?: string;
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    effective_date?: string;
    /**
     * 
     * @type {number}
     * @memberof DTAVersion
     */
    grace_period_days?: number;
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    ingestion_spec_id?: string;
    /**
     * 
     * @type {VersionStatus}
     * @memberof DTAVersion
     */
    status: VersionStatus;
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof DTAVersion
     */
    workflow_stage?: string;
}



/**
 * Check if a given object implements the DTAVersion interface.
 */
export function instanceOfDTAVersion(value: object): value is DTAVersion {
    if (!('change_reason' in value) || value['change_reason'] === undefined) return false;
    if (!('change_source' in value) || value['change_source'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by' in value) || value['created_by'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function DTAVersionFromJSON(json: any): DTAVersion {
    return DTAVersionFromJSONTyped(json, false);
}

export function DTAVersionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTAVersion {
    if (json == null) {
        return json;
    }
    return {
        
        'change_reason': json['change_reason'],
        'change_source': json['change_source'],
        'created_at': json['created_at'],
        'created_by': json['created_by'],
        'data_stream_id': json['data_stream_id'] == null ? undefined : json['data_stream_id'],
        'document_content': json['document_content'] == null ? undefined : DTADocumentContentFromJSON(json['document_content']),
        'domains': json['domains'] == null ? undefined : json['domains'],
        'dta_status': json['dta_status'] == null ? undefined : json['dta_status'],
        'effective_date': json['effective_date'] == null ? undefined : json['effective_date'],
        'grace_period_days': json['grace_period_days'] == null ? undefined : json['grace_period_days'],
        'ingestion_spec_id': json['ingestion_spec_id'] == null ? undefined : json['ingestion_spec_id'],
        'status': VersionStatusFromJSON(json['status']),
        'version': json['version'],
        'workflow_stage': json['workflow_stage'] == null ? undefined : json['workflow_stage'],
    };
}

export function DTAVersionToJSON(json: any): DTAVersion {
    return DTAVersionToJSONTyped(json, false);
}

export function DTAVersionToJSONTyped(value?: DTAVersion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'change_reason': value['change_reason'],
        'change_source': value['change_source'],
        'created_at': value['created_at'],
        'created_by': value['created_by'],
        'data_stream_id': value['data_stream_id'],
        'document_content': DTADocumentContentToJSON(value['document_content']),
        'domains': value['domains'],
        'dta_status': value['dta_status'],
        'effective_date': value['effective_date'],
        'grace_period_days': value['grace_period_days'],
        'ingestion_spec_id': value['ingestion_spec_id'],
        'status': VersionStatusToJSON(value['status']),
        'version': value['version'],
        'workflow_stage': value['workflow_stage'],
    };
}
